// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__37r8k","filesListContainer":"PosDisputesFiles_filesListContainer__3q-h3","filesButton":"PosDisputesFiles_filesButton__2esOy"};